class URLHelper {

  static redirect(uri) {
    window.location.href = uri;
  }

}

module.exports = URLHelper;


// WEBPACK FOOTER //
// ./src/utils/URLHelper.js